import { render } from "./listing-review.vue?vue&type=template&id=3f5633ee"
import script from "./listing-review.vue?vue&type=script&lang=js"
export * from "./listing-review.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__